import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { MapComponent } from "./components/MapComponent";
import { InventoryCanvas } from "./components/InventoryComponent";
import { InputComponent } from "./components/InputComponent";
import { AccountComponent } from "./components/AccountComponent";

// Expose the web components to the browser
window.customElements.define("room-map", MapComponent);
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("game-inventory", InventoryCanvas);
window.customElements.define("game-input", InputComponent);
window.customElements.define("account-info", AccountComponent);
